// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-main-container{height:calc(100% - 60px);overflow:auto;padding:0 1em 1em}@media print{.layout-main-container{border:none;height:100%;overflow:visible}}\n", ""]);
// Exports
module.exports = exports;
